<template>
    <div class="searchProduct">
        <div class="img-list">
            <div class="item" v-for="(i,index) in setTingObj.goodsList.list" :key="index" v-if="i.pic">
                <i class="iconfont ooicon-error-fill" @click="remove(index)"></i>
                <img :src="i.pic">
            </div>
        </div>
        <GridSelectLi
            style="width: 186px"
            title="选择商品"
            labelName="productName"
            labelValue="id"
            :limit="1"
            showType="button"
            size="small"
            placeholder="请选择商品"
            @getValue="getValuebrandId"
            :columns="PRODUCT_code"
            :searchs="PRODUCT_search"
            dataListUrl="/shop/product/findList"
            entityBeanName="shopProduct"
            queryEntityUrl="/shop/product/get"
        >
        </GridSelectLi>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { PRODUCT1, PRODUCT_SEARCH1, STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: { GridSelectLi },
    data(){
        return{
            PRODUCT_code: PRODUCT1,
            PRODUCT_search: PRODUCT_SEARCH1,
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
        }
    },
    props:{
        setTingObj:{
            type: Object,
            default: {}
        }
    },
    methods:{
        getValuebrandId(value) {
            get("/shop/product/get",{
                id: value
            }).then((res)=>{
                if(res.success){
                    if(this.setTingObj.goodsList.list[0].pic === ''){
                        this.setTingObj.goodsList.list = []
                    }

                    this.setTingObj.goodsList.list.push({
                        id: res.shopProduct.id,
                        name: res.shopProduct.productName,
                        pic: res.shopProduct.productPic,
                        oprice: res.shopProduct.marketPrice,
                        price: res.shopProduct.shopPrice
                    })
                }
            })
        },

        remove(index){
            this.setTingObj.goodsList.list.splice(index, 1)
            if(this.setTingObj.goodsList.list.length === 0){
                this.setTingObj.goodsList.list.push({
                    id: "",
                    name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                    pic: "",
                    oprice: "99",
                    price: "79"
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.searchProduct{
    margin-top: 10px;

    .img-list{
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .item{
            position: relative;
            flex-shrink: 0;
            width: 80px;
            height: 80px;
            margin-right: 10px;
            margin-bottom: 10px;
            border: 1px dashed #d9d9d9;

            .ooicon-error-fill{
                position: absolute;
                right: -15px;
                top: -20px;
                font-size: 28px;
                color: #000;
                z-index: 100;
            }

            img{
                width: 80px;
                height: 80px;
            }
        }
    }
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>